module.exports = __webpack_public_path__ + "img/icon-autor2.6ff33794.png";